// Helper function for sorting comparison
export const getSortComparison = (
  aValue: any,
  bValue: any,
  sortType?: string
): number => {
  // Handle null/undefined
  if (aValue == null && bValue == null) return 0;
  if (aValue == null) return -1;
  if (bValue == null) return 1;

  switch (sortType) {
    case "number":
      return Number(aValue) - Number(bValue);
    case "date":
      return new Date(aValue).getTime() - new Date(bValue).getTime();
    case "string":
    default:
      const aStr =
        typeof aValue === "object" ? JSON.stringify(aValue) : String(aValue);
      const bStr =
        typeof bValue === "object" ? JSON.stringify(bValue) : String(bValue);
      return aStr.toLowerCase().localeCompare(bStr.toLowerCase());
  }
};

// Helper function to determine next sort direction
export const getNextSortDirection = (
  currentColumn: string | null,
  currentDirection: "asc" | "desc" | null,
  clickedColumn: string
): { column: string | null; direction: "asc" | "desc" | null } => {
  if (currentColumn === clickedColumn) {
    // Same column: cycle through asc -> desc -> null
    if (currentDirection === "asc") {
      return { column: clickedColumn, direction: "desc" };
    } else if (currentDirection === "desc") {
      return { column: null, direction: null };
    } else {
      return { column: clickedColumn, direction: "asc" };
    }
  } else {
    // New column: start with asc
    return { column: clickedColumn, direction: "asc" };
  }
};

// Helper function to sort data array
export const sortData = (
  data: any[],
  columns: any[],
  sortState: { column: string | null; direction: "asc" | "desc" | null }
): any[] => {
  if (!sortState.column || !sortState.direction) {
    return data;
  }

  const column = columns.find((col) => col.key === sortState.column);
  if (!column || !column.sortable) {
    return data;
  }

  return [...data].sort((a, b) => {
    const aValue = a[sortState.column!];
    const bValue = b[sortState.column!];

    const comparison = getSortComparison(aValue, bValue, column.sortType);
    return sortState.direction === "asc" ? comparison : -comparison;
  });
};
